import React, { useMemo } from "react";

const FilteredBodyInviasCountries = ({
    countries = [],
    selected = [],
    setSelected,
}) => {
    const selectedSet = useMemo(() => new Set(selected), [selected]);
    return (
        <div className="invias-country">
            <div className="invias-country-list">
                {countries.map((country) => {
                    const checked = selectedSet.has(country.value);
                    return (
                        <label key={country.value} className={`geo-row ${checked ? "is-on" : ""}`}>
                            <input
                                type="checkbox"
                                className="geo-check"
                                checked={checked}
                                onChange={() => {
                                    setSelected?.((prev) => {
                                        const next = new Set(Array.isArray(prev) ? prev : []);
                                        if (next.has(country.value)) next.delete(country.value);
                                        else next.add(country.value);
                                        return Array.from(next);
                                    });
                                }}
                            />
                            <span className="geo-label">{country.label}</span>
                        </label>
                    );
                })}
            </div>

            <style>{`
                .invias-country{
                    width:100%;
                    display:flex;
                    flex-direction:column;
                    gap:8px;
                }
                .invias-country-list{
                    width:100%;
                    display:flex;
                    flex-direction:column;
                    gap:8px;
                }
                .geo-row{
                    display:flex;
                    align-items:center;
                    gap:10px;
                    padding:8px 8px;
                    border-radius:10px;
                    cursor:pointer;
                    user-select:none;
                    border:1px solid transparent;
                    transition:background .15s ease,border-color .15s ease;
                }
                .geo-row:hover{ background:rgba(0,0,0,.03); }
                .geo-row.is-on{ background:rgba(0,102,153,.10); border-color:rgba(0,102,153,.25); }
                .geo-label{ white-space:nowrap; overflow:hidden; text-overflow:ellipsis; max-width:100%; }
                .geo-check{
                    -webkit-appearance:none !important;
                    appearance:none !important;
                    width:16px; height:16px; flex:0 0 16px; margin:0;
                    border:2px solid rgba(0,0,0,.35);
                    border-radius:3px; background:#fff;
                    display:grid; place-items:center;
                    cursor:pointer; position:relative;
                }
                .geo-check:checked{ border-color:#006699; background:#006699; }
                .geo-check:checked::after{
                    content:""; width:8px; height:4px;
                    border-left:2px solid #fff;
                    border-bottom:2px solid #fff;
                    transform: rotate(-45deg);
                    margin-top:-1px;
                }
                .geo-check:disabled{ cursor:not-allowed; opacity:.6; }
            `}</style>
        </div>
    );
};

export default FilteredBodyInviasCountries;
